"use strict";

var marko_template = module.exports = require("marko/dist/vdom").t(),
    marko_component = {
    onCreate: function () {
        this.state = {
            outlines: [],
            editOutline: false
        };
    },
    onInput: function ({list}) {
        list && this.setState('outlines', list);
    },
    onMount: function () {
        this.moveOptions = {
            axis: 'Y',
            connectWith: '.sortable-list',
            handle: '.move-handle',
            torelance: 'pointer',
            cursor: 'move',
            scroll: false,
            revert: true,
            zIndex: 100,
            stop: (e, ui) => {
                const $item = ui.item, $parent = $item.closest('.sortable-list'), fromIndex = $item.data('index');
                let toIndex, counter = 0;
                $parent.children().each(function () {
                    if ($(this).data('index') == fromIndex)
                        toIndex = counter;
                    counter++;
                });
                fromIndex != toIndex && this.onProgramOutlineMove(fromIndex, toIndex, $item);
            }
        };
        $('.sortable-list').sortable(this.moveOptions);
    },
    onFind: function () {
        const payload = {
            targets: [
                'course',
                'activity'
            ],
            label: 'Search for courses and activities to add',
            callback: function (type, formated, raw) {
                const {title, poster, reference} = formated, {description, instructors, isPublished} = raw;
                if (this.state.outlines.filter(({id}) => {
                        return reference == id;
                    }).length) {
                    console.log('Adding an already added course');
                    return;
                }
                if (!isPublished) {
                    console.log('Cannot add an unpublished course to a program');
                    return;
                }
                this.onProgramOutlineInsert({
                    id: reference,
                    type,
                    poster,
                    title,
                    description,
                    instructors,
                    isPublished
                });
                window.Extensions.quit('SmartSearch');
            }.bind(this)
        };
        window.Extensions.run('SmartSearch', payload);
    },
    onProgramOutlineInsert: function (outline) {
        if (!outline)
            return;
        this.state.outlines.push(outline);
        this.emit('change', this.state.outlines);
        $('.sortable-list').sortable(this.moveOptions);
    },
    onProgramOutlineEdit: function (outline, index) {
        if (!outline)
            return;
        this.state.editOutline = {
            index,
            outline,
            fn: function (updates) {
                this.onApplyProgramOutlineEdit(index, updates);
            }.bind(this)
        };
    },
    onProgramOutlineMove: function (fromIndex, toIndex, $item) {
        const _outline = newObject(this.state.outlines[fromIndex]);
        if (!_outline)
            return;
        this.state.outlines.splice(fromIndex, 1);
        this.state.outlines.splice(toIndex, 0, _outline);
        this.emit('change', this.state.outlines);
    },
    onProgramOutlineDelete: function (index) {
        this.emit('dialog', {
            type: 'warning',
            message: 'Confirm delete',
            actions: {
                yes: {
                    active: true,
                    fn: function () {
                        this.state.outlines.splice(index, 1);
                        this.emit('change', this.state.outlines.length ? this.state.outlines : '');
                    }.bind(this)
                }
            }
        });
    },
    onApplyProgramOutlineEdit: function (index, outline) {
        if (!outline)
            return;
        Object.assign(this.state.outlines[index], outline);
        this.emit('change', this.state.outlines);
    },
    onDismissEdit: function () {
        this.state.editOutline = false;
    }
},
    components_registry_browser = require("marko/dist/runtime/components/registry-browser"),
    marko_registerComponent = components_registry_browser.r,
    marko_componentType = marko_registerComponent("/MP.WEB$2.0/src/views/smoothy~1.0/pages/Programs/create/Content/components/Outlines.marko", function() {
      return module.exports;
    }),
    marko_renderer = require("marko/dist/runtime/components/renderer"),
    marko_defineComponent = require("marko/dist/runtime/components/defineComponent"),
    Locale_template = require("../../../../../../components/Locale/index.marko"),
    marko_loadTag = require("marko/dist/runtime/helpers/load-tag"),
    Locale_tag = marko_loadTag(Locale_template),
    Bx_template = require("../../../../../../components/Bx/index.marko"),
    Bx_tag = marko_loadTag(Bx_template),
    route_link_template = require("marko-router5/src/components/route-link/index.marko"),
    route_link_tag = marko_loadTag(route_link_template),
    marko_classValue = require("marko/dist/runtime/helpers/class-value"),
    Row_template = require("../../../../../../components/Row/index.marko"),
    Row_tag = marko_loadTag(Row_template),
    marko_forOf = require("marko/dist/runtime/helpers/for-of"),
    marko_assign = require("marko/dist/runtime/helpers/assign"),
    Outline_template = require("../../../components/Outline.marko"),
    Outline_tag = marko_loadTag(Outline_template),
    EditOutline_template = require("./EditOutline.marko"),
    EditOutline_tag = marko_loadTag(EditOutline_template),
    marko_attrs0 = {
        "class": "text-center"
      },
    marko_attrs1 = {
        "class": "w-100"
      },
    marko_createElement = require("marko/dist/runtime/vdom/helpers/v-element"),
    marko_const = require("marko/dist/runtime/vdom/helpers/const"),
    marko_const_nextId = marko_const("40b780"),
    marko_node0 = marko_createElement("br", null, "2", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_node1 = marko_createElement("br", null, "3", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_node2 = marko_createElement("img", {
        src: "/images/illustration/course-activites.svg",
        alt: "Add Program Content Placeholder",
        style: "width:35%"
      }, "4", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_node3 = marko_createElement("br", null, "5", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_node4 = marko_createElement("br", null, "6", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_node5 = marko_createElement("br", null, "7", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_attrs2 = {
        "class": "text-muted"
      },
    marko_node6 = marko_createElement("br", null, "10", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_node7 = marko_createElement("br", null, "11", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_attrs3 = {
        "class": "btn btn-secondary btn-lg mx-25"
      },
    marko_attrs4 = {
        "class": "align-middle",
        style: "color:inherit"
      },
    marko_attrs5 = {
        "class": "position-relative"
      },
    marko_node8 = marko_createElement("br", null, "28", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_attrs6 = {
        "class": "sortable-list"
      },
    marko_node9 = marko_createElement("br", null, "31", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_attrs7 = {
        "class": "col"
      },
    marko_attrs8 = {
        "class": "font-medium-3"
      },
    marko_attrs9 = {
        "class": "col text-right"
      },
    marko_attrs10 = {
        "class": "btn btn-secondary m-25"
      },
    marko_attrs11 = {
        "class": "btn btn-secondary float-right mx-25"
      },
    marko_attrs12 = {
        "class": "align-middle",
        style: "color:inherit"
      };

require("jquery-ui/ui/widgets/sortable");

function render(input, out, __component, component, state) {
  var data = input;

  if (!state.outlines.length) {
    out.be("div", marko_attrs0, "0", component);

    out.be("div", marko_attrs1, "1", component);

    out.n(marko_node0, component);

    out.n(marko_node1, component);

    out.n(marko_node2, component);

    out.n(marko_node3, component);

    out.n(marko_node4, component);

    out.n(marko_node5, component);

    out.be("h5", marko_attrs2, "8", component);

    Locale_tag({
        renderBody: function(out) {
          out.t("Find & add courses & activites to the programs");
        }
      }, out, __component, "9");

    out.ee();

    out.n(marko_node6, component);

    out.n(marko_node7, component);

    out.be("button", marko_attrs3, "12", component, null, 0, {
        onclick: __component.d("click", "onFind", false)
      });

    out.be("span", marko_attrs4, "13", component);

    Locale_tag({
        text: "Search"
      }, out, __component, "14");

    out.ee();

    out.ee();

    out.ee();

    out.ee();
  } else {
    out.be("div", marko_attrs5, "15", component);

    Row_tag({
        class: "m-0",
        renderBody: function(out) {
          out.be("div", marko_attrs7, "17", component);

          out.be("h6", marko_attrs8, "18", component);

          Locale_tag({
              renderBody: function(out) {
                out.t("Program Outlines\"");
              }
            }, out, __component, "19");

          out.ee();

          out.ee();

          out.be("div", marko_attrs9, "20", component);

          if (input.editable) {
            out.be("button", marko_attrs10, "21", component, null, 0, {
                onclick: __component.d("click", "onFind", false)
              });

            Bx_tag({
                type: "plus",
                class: "left",
                style: "color:inherit"
              }, out, __component, "22");

            Locale_tag({
                text: "Add",
                class: "align-middle",
                style: "color:inherit"
              }, out, __component, "23");

            out.ee();
          }

          route_link_tag({
              href: "/preview-program/" + input.programId,
              class: "btn btn-secondary m-25",
              renderBody: function(out) {
                Locale_tag({
                    text: "Preview"
                  }, out, __component, "25");
              }
            }, out, __component, "24");

          out.be("button", {
              "class": marko_classValue(("btn btn-" + (input.editable ? "primary" : "success")) + " m-25")
            }, "26", component, null, 1, {
              onclick: __component.d("click", () => component.emit('update-program', 'isPublished', input.editable ), false)
            });

          Locale_tag({
              text: input.editable ? "Publish" : "Unpublish"
            }, out, __component, "27");

          out.ee();

          out.ee();
        }
      }, out, __component, "16");

    out.n(marko_node8, component);

    out.be("div", marko_attrs6, "29", component);

    var $for$0 = 0;

    marko_forOf(state.outlines, function(outline, index) {
      var $keyScope$0 = "[" + (($for$0++) + "]");

      Outline_tag(marko_assign({
          index: index
        }, outline, {
          editable: input.editable
        }), out, __component, "30" + $keyScope$0, [
        [
          "edit",
          "onProgramOutlineEdit",
          false,
          [
              outline,
              index
            ]
        ],
        [
          "delete",
          "onProgramOutlineDelete",
          false,
          [
              index
            ]
        ]
      ]);
    });

    out.ee();

    out.n(marko_node9, component);

    if (state.outlines.length > 10) {
      out.be("button", marko_attrs11, "32", component, null, 0, {
          onclick: __component.d("click", "onFind", false)
        });

      Bx_tag({
          type: "plus",
          class: "left",
          style: "color:inherit"
        }, out, __component, "33");

      out.be("span", marko_attrs12, "34", component);

      Locale_tag({
          text: "Add"
        }, out, __component, "35");

      out.ee();

      out.ee();
    }

    if (state.editOutline) {
      EditOutline_tag(state.editOutline, out, __component, "36", [
        [
          "dismiss",
          "onDismissEdit",
          false
        ],
        [
          "edit-content",
          "onToggleEditContent",
          false,
          [
              state.editOutline
            ]
        ]
      ]);
    }

    out.ee();
  }
}

marko_template._ = marko_renderer(render, {
    e_: marko_componentType
  }, marko_component);

marko_template.Component = marko_defineComponent(marko_component, marko_template._);
